module.exports = __webpack_public_path__ + "b6d96e0b2e2a0b433c5976d08ff63d65.pdf";